import type { IInvestorCashflowCalculationInputs } from '@condo/domain';

export const REDIRECT_URL_STORAGE_KEY = 'redirect-url';
export const MARKED_ESTATES_LIST_STORAGE_KEY = 'marked-estates';
export const PAGE_SIZE = 50;
export const INVESTOR_CASH_FLOW_PORTAL_DEFAULT_VALUES: Partial<IInvestorCashflowCalculationInputs> = {
    appreciationValuePercent: 0.03,
    propertySoldAfterYears: 10,
};
